import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const apiKeyCreatedV1Schema = eventEnvelopeSchema.extend({
  merchantName: z.string().min(1).max(256).optional(),
  keyId: z.string().min(1).max(256),
  keyPreview: z.string().min(1).max(64).optional(),
  rateLimit: z.number().int().positive().optional(),
  permissionsCount: z.number().int().nonnegative().optional(),
});

export type ApiKeyCreatedV1 = z.infer<typeof apiKeyCreatedV1Schema>;

export const API_KEY_CREATED_V1_DETAIL_TYPE = 'api-key.created.v1' as const;
